module.exports = __webpack_public_path__ + "img/ROROCCCO01220326.132da9b4.png";